import { Colour } from 'lib/common/components/Text/types';

import { STATUS_TO_ICON_COLOUR_MAP } from 'lib/common/constants/presenceStates';

const statusIconColour = (status: string): Colour => STATUS_TO_ICON_COLOUR_MAP[status] || 'yellow';

export default statusIconColour;
